class WaveOne extends HTMLElement {
  constructor() {
    super();
    // gsap.registerPlugin(MorphSVGPlugin);

    this.wave = this.querySelector('#wave');
    this.waveAttr = this.wave.getAttribute('d');

    const tl = gsap.timeline({
      repeat: -1,
      repeatDelay: -0.1,
      repeatRefresh: true,
      delay: 1,
      yoyo: true,
      yoyoEase: true
    });

    tl.to(this.wave, 0, {
      morphSVG: this.wave
      // morphSVG: {
      //   shape: '#wave'
      //   // type: 'rotational'
      // }
      // ease: 'power1.inOut'
    })
      .to(this.wave, 2.5, {
        morphSVG: '#wave2'
        // morphSVG: {
        //   shape: '#wave2'
        //   // type: 'rotational'
        // }
        // ease: 'power1.inOut'
      })
      .to(this.wave, 2.5, {
        morphSVG: '#wave3'
        // morphSVG: {
        //   shape: '#wave3'
        //   // type: 'rotational'
        // }
        // ease: 'power1.inOut'
      })
      .to(this.wave, 2.5, {
        morphSVG: this.waveAttr
        // morphSVG: {
        //   shape: this.waveAttr
        //   // type: 'rotational'
        // }
        // ease: 'power1.inOut'
      });
  }
}

customElements.define('wave-one', WaveOne);
